
<template>
  <Nav-bar :has_back="true" :has_right="false" title="提交申请成功"></Nav-bar>
  <div class="top-margin"></div>
  <div class="container">
    <img
      src="@/images/charging_package_topup_result_success.png"
      class="title-icon"
    />
    <div class="t-f20-c1a font-bold m-t-10">申请成功</div>
    <div class="info-v">
      <div class="item-v">
        <span class="t-f14-c66">发票抬头:</span>
        <span class="t-f14-c1a r-t">{{ invoicesData.titleInfo.title }}</span>
      </div>
      <div class="item-v">
        <span class="t-f14-c66">订单数:</span>
        <span class="t-f14-c1a r-t"
          >{{ invoicesData.invoicesList.length }} 个</span
        >
      </div>
      <div class="item-v" style="border: none">
        <span class="t-f14-c66">发票总额:</span>
        <span class="t-f14-c1a r-t"
          >{{ invoicesData.invoicesTotalNumber }} 元</span
        >
      </div>
      <div class="display_flex">
        <van-button plain type="primary" size="normal" class="main-btn" @click="goIndex"
          >返回首页</van-button
        >
        <van-button
          type="primary"
          size="normal"
          class="main-btn m-l-10"
          @click="toRecord"
          >开票记录</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

let router;
let storeContext;
export default {
  components: {
    NavBar,
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goBack, false);
    }
  },
  unmounted() {
    storeContext.commit("clearInvoices");
    window.removeEventListener("popstate", this.goBack, false);
  },
  methods: {
    goBack() {
      storeContext.commit("setHomeRouter", "home");
      router.replace("/");
    },
  },
  setup() {
    router = useRouter();
    storeContext = useStore();
    const invoicesData = storeContext.state.invoicesData;

    return { toRecord, router, invoicesData, goIndex };
  },
};
function goIndex() {
  router.replace("/");
}
function toRecord() {
  router.replace("/user/receipt/receipt_record");
}
</script>
<style scoped>
.display_flex {
  margin-top: 30px;
}
.r-t {
  position: absolute;
  right: 0px;
  transform: translateY(-50%);
  top: 50%;
}
.item-v {
  text-align: left;
  line-height: 40px;
  border-bottom: 1px solid #ebebeb;
  position: relative;
}
.info-v {
  margin-top: 50px;
}
.container {
  background: #fff;
  padding: 20px;
  margin: 10px;
  border-radius: 5px;
  text-align: center;
}
.title-icon {
  width: 60px;
  height: 60px;
  margin-top: 30px;
}
</style>